import React from "react";
import { Col, Row } from "reactstrap";
import Modal from "components/common/Modal/Modal";
import UploadButtonComponent from "components/common/UploadButton/UploadButtonComponent";
import UploadInventoryIcon from "assets/images/icn_upload_inventory.svg";
import UploadPriceIcon from "assets/images/icn_upload_prices.svg";
import UploadProductAttributeIcon from "assets/images/product_attributes.svg";
import { IUploadModalInterface } from "./UploadModal.interface";
import SampleFileDownloadComponent from "./SampleFileDownloadComponent/SampleFileDownloadComponent";
import { acceptableFormats } from "config/constants";

const UploadModal: React.FunctionComponent<IUploadModalInterface> = (
  props: IUploadModalInterface
) => {
  const {
    showModal,
    closeModal,
    handleUploadAttributes,
    handleUploadInventory,
    handleUploadPrices,
    roles,
  } = props;

  return (
    <Modal
      modalHeading="Add a batch"
      showModal={showModal}
      closeModalHandler={closeModal}
      showProgressString={false}
      modalBodyClass="batch-modal"
    >
      <Row className="py-3">
        {roles?.includes("Commando God") ||
          roles?.includes("Caps Upload")
          // || roles?.includes("Commerical Supervisor")
          ? (
          <Col>
            <img
              className="upload_inventory_icon"
              src={UploadInventoryIcon}
              alt="upload-inventory-icon"
            />
            <UploadButtonComponent
              id="addUpdateInventoryBatch"
              buttonText="Upload Inventory"
              fileFormat={acceptableFormats.csv}
              handleFileChange={handleUploadInventory}
              classes="button-medium"
            />
          </Col>
        ) : (
          <></>
        )}
        {roles?.includes("Commando God")
          // || roles?.includes("Commercials") ||
          // roles?.includes("Commerical Supervisor")
          ? (
          <Col>
            <img
              className="upload_prices_icon"
              src={UploadPriceIcon}
              alt="upload-prices-icon"
            />
            <UploadButtonComponent
              id="addUpdatePricesBatch"
              buttonText="Upload Prices"
              fileFormat={acceptableFormats.csv}
              handleFileChange={handleUploadPrices}
              classes="button-medium"
            />
          </Col>
        ) : (
          <></>
        )}
        <>
          {roles?.includes("Commando God")
            // || roles?.includes("Commercials") ||
            // roles?.includes("Commerical Supervisor")
            ? (
            <Col>
              <img
                className="upload_attributes_icon"
                src={UploadProductAttributeIcon}
                alt="upload-attributes-icon"
              />
              <UploadButtonComponent
                id="addUpdateProductAttributes"
                buttonText="Product attributes"
                fileFormat={acceptableFormats.csv}
                handleFileChange={handleUploadAttributes}
                classes="button-medium"
              />
            </Col>
          ) : (
            <></>
          )}
        </>
        <SampleFileDownloadComponent />
      </Row>
    </Modal>
  );
};

export default UploadModal;
